var e={SkeletonRow:"Skeleton__SkeletonRow-ww6",fakeContent:"Skeleton__fakeContent-uSC"};export{e as default};
